export enum FeatureFlag {
  DraftBulletins = "draft_bulletins",
  ExpiringBulletins = "expiringBulletins",
  ClickableAvatars = "clickableAvatars",
}
